// extracted by mini-css-extract-plugin
export var menuIcon = "_k9-0";
export var menuIconInline = "_k9-1";